import api from '../api';
import type { StaffProfile } from '@alascorporation/access-control';

export interface StaffUser {
  id: string;
  name: string;
  email: string;
  role: StaffProfile;
  // gestion-custom-roles-permissions: set when a database-backed custom role
  // (rather than the legacy `role` enum) governs this user's authorization.
  roleId: string | null;
  staffRole: { id: string; name: string; isBuiltIn: boolean } | null;
  isActive: boolean;
  mustChangePassword: boolean;
  createdAt: string;
}

function data<T>(res: { data: { data: T } }): T {
  return res.data.data;
}

// A staff account is assigned either a legacy built-in `profile` or a
// database-backed custom `roleId` — never both, never neither.
export type StaffUserRoleAssignment = { profile: StaffProfile; roleId?: undefined } | { profile?: undefined; roleId: string };

export const staffUsersAdmin = {
  // Listing goes through useServerTable directly against '/admin/staff-users'
  // (see StaffUsersPage) for standard search/sort/pagination — not through a
  // dedicated method here, except this plain list for pickers (e.g. the
  // "asignar experto" selector in CategoryExpertsPage) that don't need a
  // full table.
  list: (search?: string) =>
    api.get<{ data: { users: StaffUser[]; total: number } }>('/admin/staff-users', { params: { limit: 200, search: search || undefined } }).then((res) => res.data.data.users),

  create: (body: { name: string; email: string } & StaffUserRoleAssignment) =>
    api.post<{ data: { user: StaffUser; tempPassword: string } }>('/admin/staff-users', body).then(data),

  update: (id: string, body: Partial<StaffUserRoleAssignment> & { isActive?: boolean }) =>
    api.patch<{ data: { user: StaffUser } }>(`/admin/staff-users/${id}`, body).then(data),

  resetPassword: (id: string) =>
    api.post<{ data: { tempPassword: string } }>(`/admin/staff-users/${id}/reset-password`).then(data),
};
